<template>
    <div class="tslx-page">
        <div class="phone-list">
            <div class="phone-item" v-for="(item, index) in list" :key="index" @click="call(item.ph)">
                <span class="dept-name">{{ item.name }}</span>
                <span class="phone-number">{{ item.ph }}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [
                { name: '市住建局', ph: "0527-84387393" },
                { name: '沐阳城管局', ph: "0527-83512345" },
                { name: '泗阳城管局', ph: "0527-81820007" },
                { name: '泗洪城管局', ph: "0527-80791311" },
                { name: '宿豫区城管局', ph: "0527-84468832" },
                { name: '宿城区城管局', ph: "0527-84500611" },
                { name: '经开区城管局', ph: "0527-88857183" },
                { name: '湖滨新区城管局', ph: "0527-84837817" },
                { name: '洋河新区旅游交通建设局', ph: "0527-82668309" },
                { name: '苏宿园区城管局', ph: "0527-82868321" },
            ],
        }
    },
    methods: {
        call(ph) {
            if (ph != '') {
                window.location.href = 'tel://' + ph
            }
        },
    },
}
</script>
<style lang="less" scoped>
    .tslx-page {
        min-height: calc(100vh - 46px);
        background-color: #f5f5f5;
        padding: 15px;

        .phone-list {
            background-color: #fff;
            border-radius: 15px;
            padding: 0 15px;
            .phone-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 16px 0;
                border-bottom: 1px solid #eee;

                &:last-child {
                    border-bottom: none;
                }

                .dept-name {
                    font-size: 15px;
                    color: #4A4A4A;
                }

                .phone-number {
                    font-size: 14px;
                    color: #327BF0;
                }
            }
        }
    }
</style>